__turbopack_context__.v({
  "Root": "_5sMb3q_Root",
  "TextWrapper": "_5sMb3q_TextWrapper",
  "skeleton-loading": "_5sMb3q_skeleton-loading",
});
